export const GET_REPORTSUBSCRIPTION = `
    query ReportSuscription($Input: requestReportSuscription!) {
      reportSuscription(Input: $Input) {
        message
        content {
          name_subs
          state_sub
          count_sub
        }
        technicianData {
          name_sub
          type_report {
            fullName_technician
            state_TechSub
            startSub
            endSub
          }
        }
      }
    }
`;

export const GET_REPORTTECHNICIANS = `
  query reportTechnician($Input: RequestReportTechnicians) {
    reportTechnician(Input: $Input) {
      message
      techniciansData {
        id
        name_technician
        name_city
        name_skills
        rates
        status
      }
    }
  }
`;